<form [formGroup]="otherSubjectsForm()">
    <h3 class="secondary">{{ 'appointment.header.existing-customer' | apContent }}</h3>
    <ap-radio-group
        data-bb="existingCustomerRadioGroup"
        [control]="otherSubjectsForm().controls.existingCustomer"
        [inline]="true"
        [description]="'appointment.header.existing-customer' | apContent"
        [messages]="getErrorMessage('appointment.header.existing-customer')"
        [descriptionHidden]="true"
    >
        <ap-radio-button
            data-bb="existingCustomerRadioButton"
            [label]="'answer.label.true' | apContent"
            [formControl]="otherSubjectsForm().controls.existingCustomer"
            name="existingCustomer"
            class="ap-margin-bottom-0"
            [value]="true"
        >
        </ap-radio-button>
        <ap-radio-button
            data-bb="existingCustomerRadioButton"
            [label]="'answer.label.false' | apContent"
            [formControl]="otherSubjectsForm().controls.existingCustomer"
            name="existingCustomer"
            class="ap-margin-bottom-0"
            [value]="false"
        >
        </ap-radio-button>
    </ap-radio-group>
    @if (isExistingCustomer) {
        <ap-radio-group
            data-bb="bankLabelRadioGroup"
            [control]="otherSubjectsForm().controls.bank"
            [inline]="true"
            [description]="'appointment.header.existing-customer' | apContent"
            [messages]="getErrorMessage('appointment.header.existing-customer')"
            [descriptionHidden]="true"
        >
            <ap-radio-button
                data-bb="bankLabelRadioButton"
                [label]="'answer.label.asn' | apContent"
                name="bankLabel"
                [formControl]="otherSubjectsForm().controls.bank"
                [value]="bank.ASN"
            >
            </ap-radio-button>
            <ap-radio-button
                data-bb="bankLabelRadioButton"
                [label]="'answer.label.sns' | apContent"
                name="bankLabel"
                [formControl]="otherSubjectsForm().controls.bank"
                [value]="bank.SNS"
            >
            </ap-radio-button>
            <ap-radio-button
                data-bb="bankLabelRadioButton"
                [label]="'answer.label.rgb' | apContent"
                name="bankLabel"
                [formControl]="otherSubjectsForm().controls.bank"
                [value]="bank.RGB"
            >
            </ap-radio-button>
        </ap-radio-group>
    }

    <h3 class="secondary">{{ 'situations.extraInfo.title' | apContent }}</h3>
    <p>{{ 'situations.extraInfo.description' | apContent }}</p>

    <ap-textarea
        data-bb="otherSubjectsInput"
        [maxCharacters]="maxLength.otherSubjects"
        [messages]="getErrorMessage('situations.extraInfo.content_label')"
        label="{{ 'situations.extraInfo.content_label' | apContent }}"
        formControlName="otherSubjects"
    >
    </ap-textarea>
</form>
